import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { observer } from 'mobx-react-lite';

import { BaseBlock } from '../../schedule/components/styled-strips';
import Styles from '../stripboard.module.scss';
import { StripProps } from './stripboard-table';

import styles from './day-break-strip.module.scss';
export type DayBreakStripProps = StripProps & {
  centerText: string;
  endText: React.ReactNode;
};

const DayBreakStripComponent: React.FC<DayBreakStripProps> = observer(
  ({ row, dayId, centerText, endText }) => {
    const strip = row.original;

    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
      id: strip._id,
      data: {
        dayId,
        type: 'row',
        row: strip,
      },
      disabled: true,
      animateLayoutChanges: () => true,
      transition: {
        duration: 150,
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
      },
    });

    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
    };

    return (
      <div
        className={Styles.stickyStrip}
        data-direction="bottom"
        style={style}
        ref={setNodeRef}
        {...attributes}
        {...listeners}
      >
        <div className={Styles.stickyStripContent}>
          <div />

          <div className={styles['center-wrapper']}>
            <BaseBlock className={styles['end-of-day']}>
              <p className={styles['day-text']}>{centerText}</p>
            </BaseBlock>
          </div>

          {endText}
        </div>
      </div>
    );
  },
);

export const DayBreakStrip = React.memo(DayBreakStripComponent);
